import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./FixedAssetsFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import FixedAssetsFormStepOne from "./FixedAssetsFormSteps/FixedAssetsFormStepOne";

const FixedAssetsForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState({});

  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        fixedAssetsType: _initialValues?.fixedAssetsType?.uuid
          ? { value: _initialValues?.fixedAssetsType?.uuid }
          : null,
        fixedAssetsName: _initialValues?.fixedAssetsName?.uuid
          ? { value: _initialValues?.fixedAssetsName?.uuid }
          : null,
        model: _initialValues?.model?.value,

        producer: _initialValues?.producer?.value,
      });
      return;
    }

    // setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="FixedAssetsForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <FixedAssetsFormStepOne {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default FixedAssetsForm;
